import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import styled from 'styled-components';


const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`

const ModelNoReadOnly = ({k, row, onClickEdit,handleDeleteClick,page, rowsPerPage,tableFontSize,
   SubmitButton
 }) =>{
   
   return(        
       <>
        <TableRow key={k} name={row.categ}>
           <TableCell component="th" scope="row" sx={{ fontSize: tableFontSize}} align='center'>
             {(page)*(rowsPerPage)+k+1}
           </TableCell>

           <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
             {row?.modelno}
           </TableCell>

           <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
             {row?.asset}
           </TableCell>

           <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
             {row?.category}
           </TableCell>

            <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
             {row?.brand}
            </TableCell>    
       

           <TableCell align="left" sx={{ fontSize: tableFontSize}}>            
             <ButtonWrapper>
               <SubmitButton  type="button" style={{backgroundColor:"#ed6c02", color:"lightgreen", height:"35px", margin:"0px"}} onClick ={(e)=>onClickEdit(e,k,row.id)}>Edit
               </SubmitButton>
               <SubmitButton  type="button" style={{backgroundColor:"#D32F2F", color:"lightgreen", height:"35px"}} onClick ={(e)=>handleDeleteClick(e,k, row.id)}>Delete
               </SubmitButton> 
             </ButtonWrapper>                                   
           </TableCell>
           
         </TableRow>     
       </>        
   )
}

export default ModelNoReadOnly